import React from 'react';

const CoinRecLogo = ({ className = "h-8" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 200 792 250" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>
          {`
            .cls-1 {
              stroke-width: 2.39px;
            }
            .cls-1, .cls-2, .cls-3, .cls-4 {
              fill: none;
              stroke: currentColor;
              stroke-miterlimit: 10;
            }
            .cls-2 {
              stroke-width: 9.78px;
            }
            .cls-2, .cls-3 {
              stroke-linecap: round;
            }
            .cls-3 {
              stroke-width: 1.75px;
            }
            .cls-5 {
              fill: currentColor;
              stroke-width: 0px;
            }
            .cls-4 {
              stroke-width: 9.43px;
            }
          `}
        </style>
      </defs>
      <path className="cls-2" d="M747.36,225.13h24.21c7.34,0,13.3,5.95,13.3,13.3v23.12"/>
      <path className="cls-2" d="M784.86,343.54v24.21c0,7.34-5.95,13.3-13.3,13.3h-23.12"/>
      <path className="cls-2" d="M627.79,262.35v-24.21c0-7.34,5.95-13.3,13.3-13.3h23.12"/>
      <path className="cls-2" d="M665.29,380.76h-24.21c-7.34,0-13.3-5.95-13.3-13.3v-23.12"/>
      <g>
        <path className="cls-5" d="M3.64,306.07c0-24.16,17.71-41.87,42.84-41.87,20.61,0,36.23,11.92,40.9,29.63h-10.95c-4.35-11.92-15.46-19.65-29.95-19.65-19,0-31.89,13.53-31.89,31.89s12.88,31.89,31.89,31.89c14.49,0,25.61-7.73,29.95-19.65h10.95c-4.67,17.71-20.29,29.63-40.9,29.63-25.12,0-42.84-17.71-42.84-41.87Z"/>
        <path className="cls-5" d="M97.04,306.07c0-24.16,17.71-41.87,42.84-41.87s42.84,17.71,42.84,41.87-17.71,41.87-42.84,41.87-42.84-17.71-42.84-41.87ZM171.76,306.07c0-18.36-12.88-31.89-31.89-31.89s-31.89,13.53-31.89,31.89,12.88,31.89,31.89,31.89,31.89-13.53,31.89-31.89Z"/>
        <path className="cls-5" d="M195.43,242.62c0-4.67,3.54-8.21,8.21-8.21s8.21,3.54,8.21,8.21-3.54,8.21-8.21,8.21-8.21-3.54-8.21-8.21ZM198.33,266.3h10.79v79.55h-10.79v-79.55Z"/>
        <path className="cls-5" d="M227.8,304.3c0-26.41,15.78-40.1,39.29-40.1s39.29,13.69,39.29,40.1v41.55h-10.79v-41.55c0-19.65-11.27-30.11-28.5-30.11s-28.5,10.47-28.5,30.11v41.55h-10.79v-41.55Z"/>
        <path className="cls-5" d="M322.17,299.63c0-24,14.17-35.43,34.95-35.43s34.79,11.43,34.79,35.75v.48h-19v-.81c0-12.88-6.44-17.55-15.78-17.55s-15.78,4.67-15.78,17.55v46.22h-19.16v-46.22Z"/>
        <path className="cls-5" d="M398.99,306.07c0-24.16,17.71-41.87,42.84-41.87s42.51,17.71,42.51,41.87v6.76h-65.22c2.58,11.6,11.43,17.71,22.71,17.71,8.54,0,14.82-2.42,18.84-7.57h20.45c-5.96,15.14-20.45,24.96-39.29,24.96-25.12,0-42.84-17.71-42.84-41.87ZM464.05,297.54c-3.06-10.63-11.76-15.94-22.22-15.94s-19.16,5.48-22.22,15.94h44.45Z"/>
        <path className="cls-5" d="M493.68,306.07c0-24.16,17.71-41.87,42.84-41.87,21.58,0,37.36,13.04,41.23,31.89h-19.32c-3.38-8.54-11.43-14.01-21.9-14.01-14.01,0-23.51,9.98-23.51,24s9.5,23.99,23.51,23.99c10.47,0,18.52-5.47,21.9-14.01h19.32c-3.86,18.84-19.65,31.89-41.23,31.89-25.12,0-42.84-17.71-42.84-41.87Z"/>
      </g>
      <polygon className="cls-5" points="145.5 294.31 133.17 294.31 127.01 304.98 133.17 315.65 145.5 315.65 151.66 304.98 145.5 294.31"/>
      <line className="cls-3" x1="150.65" y1="304.95" x2="132.17" y2="272.3"/>
      <line className="cls-3" x1="146.52" y1="337.67" x2="128.04" y2="305.02"/>
      <line className="cls-3" x1="171.2" y1="314.69" x2="133.68" y2="314.8"/>
      <line className="cls-3" x1="145.01" y1="295.1" x2="107.49" y2="295.2"/>
      <line className="cls-3" x1="164.04" y1="282.34" x2="145.19" y2="314.78"/>
      <line className="cls-3" x1="133.57" y1="295.33" x2="114.72" y2="327.77"/>
      <circle className="cls-4" cx="706.91" cy="304.84" r="39.74"/>
      <circle className="cls-1" cx="706.91" cy="304.84" r="50.81"/>
    </svg>
  );
};

export default CoinRecLogo;